import { render } from "./VabeneCategorieList.vue?vue&type=template&id=53ae912c&ts=true"
import script from "./VabeneCategorieList.vue?vue&type=script&lang=ts"
export * from "./VabeneCategorieList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__